import { Colour } from 'lib/common/components/Text/types';

import { STATUS_TO_COLOUR_MAP } from 'lib/common/constants/presenceStates';

const statusColour = (status: string): Colour => STATUS_TO_COLOUR_MAP[status] || 'pastelYellow';

export default statusColour;
